export default __webpack_public_path__ + "static/media/Pickpocket's Gloves of the Sundered Crown.034bf4b2.jpg";